import { render, staticRenderFns } from "./result-expanded.html?vue&type=template&id=af5d172a&scoped=true&"
import script from "./result-expanded.js?vue&type=script&lang=js&"
export * from "./result-expanded.js?vue&type=script&lang=js&"
import style0 from "./result-expanded.scss?vue&type=style&index=0&id=af5d172a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5d172a",
  null
  
)

export default component.exports